import writeExcelFile from 'write-excel-file/universal'
import { formatValue } from './state'

export function xlsxFor (columns, rows) {
  const data = [
    columns.map(column => ({ value: column.title, type: String, fontWeight: 'bold' })),
    ...rows.map(row => columns.map(column => {
      const value = row[column.field]
      if (value === null || value === undefined || value === '') return null
      if (column.type === 'date') {
        return { value: new Date(`${formatValue(value, column)}T00:00:00Z`), type: Date, format: 'yyyy-mm-dd' }
      }
      if (column.type === 'number') {
        return { value: Number(value), type: Number, ...(column.field === 'conversion_ratio' ? { format: '0.##"%"' } : {}) }
      }
      return { value: String(value), type: String }
    }))
  ]
  return writeExcelFile(data, {
    sheet: 'Report',
    columns: columns.map(column => ({ width: Math.min(40, Math.max(16, column.title.length + 2)) }))
  }).toBlob()
}
